<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div class="card_container" style="border-radius: 17px">
          <div class="card__header___text">
            <div>
              <h3 class="our_branches__header">
                {{ $t("text.bExpenses.title") }}
              </h3>
              <div class="dealer__icon__wrapper mt-3">
                <div class="dealer__icon__div text-center">
                  <div>
                    <img src="@/assets/img/wallet.svg" width="35px" />
                  </div>
                </div>
              </div>
              <div class="text-center mt-3">
                <h3>{{ expenses }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuelbalance_first_row_right_section mr-3 exp__bg"
          style="border-radius: 22px"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="our__branches__banner">
            <div class="row align-items-center section__row">
              <div class="col-md-6 text-center section___column_1">
                <h3 class="our__branches__banner__title">
                  {{ $t("text.bExpenses.title") }}
                </h3>
              </div>
              <div class="col-md-4 drop_down_input_group">
                <div class="drop_down_section mt-2 mr-2">
                  <div class="drop_down_div align-items-center">
                    <vue-ctk-date-time-picker
                      v-model="dateRange"
                      :max-date="maxDate"
                      :range="true"
                      :autoClose="true"
                      :locale="this.$root.$i18n.locale"
                      :custom-shortcuts="customShortcuts"
                      :color="$store.getters.getDatePickerColor"
                      format="DDMMYYYY"
                      formatted="DD/MM/YYYY"
                      :label="$t('text.calendar.dateRange')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="mt-3 pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-4 mt-3" style="padding-right: 0px">
            <div class="drivers_list">
              <div class="product_summary__wrapper" style="padding: 1px">
                <div class="input__group__block mt-5" style="width: 90%">
                  <h3 class="expense__header mt-3 text-center">
                    {{ $t("text.bExpenses.recordExpenses") }}
                  </h3>
                  <label class="required">
                    {{ $t("text.bExpenses.amount") }}
                  </label>
                  <div class="input__block" ref="amount_input_div">
                    <input
                      type="number"
                      :placeholder="this.$t('text.bExpenses.amount')"
                      class="form-control"
                      @blur="captureFormEvents($event)"
                      v-model="amount"
                    />
                  </div>
                  <div ref="amount_error"></div>
                </div>
                <div class="input__group__block mt-3" style="width: 90%">
                  <label class="required">
                    {{ $t("text.bExpenses.expenseCategory") }}
                  </label>
                  <div class="input__block">
                    <select v-model="expenseCategoryId">
                      <option value="select category">
                        {{ $t("text.bExpenses.selectCategory") }}
                      </option>
                      <option
                        :value="expCat.id"
                        v-for="expCat in expenseCategories"
                        :key="expCat.id"
                      >
                        {{ expCat.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="input__group__block mt-3" style="width: 90%">
                  <label class="required">
                    {{ $t("text.bExpenses.paymentMode") }}
                  </label>
                  <div class="input__block">
                    <select v-model="paymentMode">
                      <option value="cash">
                        {{ $t("text.bExpenses.cash") }}
                      </option>
                      <option value="cheque">
                        {{ $t("text.bExpenses.cheque") }}
                      </option>
                      <option value="transfer">
                        {{ $t("text.bExpenses.transfer") }}
                      </option>
                    </select>
                  </div>
                </div>
                <div
                  class="input__group__block mt-4"
                  ref="account_textbox"
                  style="width: 90%"
                  v-if="paymentMode === 'cheque' || paymentMode === 'transfer'"
                >
                  <label class="required">
                    {{ $t("text.bExpenses.accountNumber") }}
                  </label>
                  <div class="input__block" ref="account_number_input_div">
                    <div class="input__block" ref="account_number_input_div">
                      <select v-model="accountNumber">
                        <option value="select account">
                          {{ $t("text.bExpenses.selectAccount") }}
                        </option>
                        <option
                          :value="acc.accountNumber"
                          v-for="acc in bankAccounts"
                          :key="acc.id"
                        >
                          {{ acc.accountName }}({{ acc.accountNumber }})
                        </option>
                      </select>
                      <div ref="recip_error"></div>
                    </div>
                  </div>
                </div>

                <div class="input__group__block mt-3" style="width: 90%">
                  <label class="required"> {{ $t("text.form.date") }} </label>
                  <div class="input__block" ref="description_input_div">
                    <input
                      type="date"
                      placeholder=""
                      class="form-control w-100"
                      @blur="captureFormEvents($event)"
                      v-model="date"
                      :max="new Date().toISOString().split('T')[0]"
                    />
                  </div>
                  <div ref="description_error"></div>
                </div>

                <div class="input__group__block mt-3" style="width: 90%">
                  <label class="required">
                    {{ $t("text.bExpenses.description") }}
                  </label>
                  <div class="input__block" ref="description_input_div">
                    <input
                      type="text"
                      :placeholder="this.$t('text.bExpenses.description')"
                      class="form-control w-100"
                      @blur="captureFormEvents($event)"
                      v-model="description"
                    />
                  </div>
                  <div ref="description_error"></div>
                </div>

                <div class="input__group__block mt-3" style="width: 90%">
                  <label class=""> {{ $t("text.actionButtons.upload") }}</label>
                  <b-form-file
                    v-model="file"
                    :state="Boolean(file)"
                    :placeholder="$t('text.actionButtons.upload')"
                    accept="image/jpeg, image/png, image/gif, image/jpg"
                  >
                  </b-form-file>
                </div>

                <div class="text-center mt-4 pb-5">
                  <button
                    @click="recordExpenses($event)"
                    class="save__btn"
                    style="border-radius: 3px; font-size: 16px"
                    :disabled="isButtonDisabled ? true : null"
                    :style="[
                      isButtonDisabled
                        ? { cursor: 'not-allowed' }
                        : { cursor: 'pointer' },
                    ]"
                  >
                    {{ $t("text.bExpenses.recordExpense") }}<span></span>
                  </button>
                  <img
                    src="@/assets/img/git_loader.gif"
                    style="display: none"
                    width="35px"
                    class="ml-3 loader"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-8 mt-3">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :excelQueryCellInfo="excelQueryCellInfo"
            >
              <e-columns>
                <e-column width="40" field="index" headerText="#"></e-column>
                <e-column
                  field="date"
                  :format="formatOptions"
                  type="date"
                  width="190"
                  :headerText="$t('text.bExpenses.dateTime')"
                ></e-column>
                <e-column
                  field="expenseCategory"
                  width="180"
                  :headerText="$t('text.bExpenses.category')"
                ></e-column>
                <e-column
                  field="account"
                  width="180"
                  :headerText="$t('text.bExpenses.account')"
                ></e-column>
                <e-column
                  field="paymentMode"
                  width="180"
                  :headerText="$t('text.bExpenses.paymentMode')"
                ></e-column>
                <e-column
                  field="amount"
                  format="N2"
                  width="180"
                  :headerText="$t('text.bExpenses.amount')"
                ></e-column>
                <e-column
                  field="description"
                  width="180"
                  :headerText="$t('text.bExpenses.description')"
                ></e-column>
                <e-column
                  :template="deleteTemplate"
                  :headerText="$t('text.actionButtons.title')"
                  width="200"
                  v-if="userDetails.roles.includes('Branch Manager')"
                ></e-column>
              </e-columns>
            </ejs-grid>

            <TableLoader :showLoader="showLoader"></TableLoader>
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index.vue";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "Pump_Details",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      file: [],
      expenseCategoryId: "select category",
      formatOptions: { type: "date", format: "dd/MM/yyyy hh:mm a" },
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      pumpId: this.$route.query.id,
      pump: {},
      tanks: [],
      description: null,
      date: "",
      amount: null,
      paymentMode: "cash",
      accountNumber: "select account",
      backgroundUrl,
      expenses: null,
      formIsValid: false,
      isButtonDisabled: false,
      showLoader: false,
      branch: {},
      branchId: null,
      bankAccounts: null,
      expenseCategories: [],
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      deleteTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template:
              '<button class="delete_btn" v-on:click="removeExpenses(data.id)">this.$t("text.actionsButtons.delete")</button>',
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              removeExpenses: function (id) {
                this.$eventHub.$emit("deleteBranchExpenses", id);
              },
            },
          }),
        };
      },
    };
  },
  created() {
    this.showLoader = true;
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Expenses :: ${branch.name} Retail Outlet`;
    });
    this.$eventHub.$on("deleteBranchExpenses", (id) => {
      this.deleteExpenses(id);
    });
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
    document.title = "Expenses :: Epump Retail Outlet";
  },
  beforeDestroy() {},
  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        let st = this.$route.query.startDate;
        let ed = this.$route.query.endDate;
        if (this.branchId !== null) {
          if (st) {
            this.dateRange.start = this.pluginStartDate =
              this.$moment(st).format("D-M-YYYY");
            this.dateRange.end = this.pluginEndDate =
              this.$moment(ed).format("D-M-YYYY");

            this.startDate = this.$moment(
              this.dateRange.start,
              "DD-MM-YYYY"
            ).format("MMMM D, YYYY");
            this.endDate = this.$moment(
              this.dateRange.end,
              "DD-MM-YYYY"
            ).format("MMMM D, YYYY");
            this.date = st;
          } else {
            this.date = this.$moment().format("DD/MM/YYYY");
          }
          this.getBranchExpenses();
          this.getBankAccts();
          this.getExpenseCategories();

          $(".e-input").keyup(function (e) {
            searchFun(e);
          });
          function searchFun(event) {
            var grid =
              document.getElementsByClassName("e-grid")[0].ej2_instances[0];
            var value = event.target.value;
            grid.search(value);
          }
        }
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getBranchExpenses();
      }
    },
  },
  mounted() {},
  methods: {
    excelQueryCellInfo(args) {
      if (args.column.field == "date") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY hh:mm A");
      }
    },
    deleteExpenses(id) {
      const deleteConfirm = confirm(
        "Are you sure you want to delete this expense?"
      );
      if (deleteConfirm) {
        this.axios
          .delete(
            `${configObject.apiBaseUrl}/Branch/DeleteExpense/${id}?branchId=${this.branchId}`,
            configObject.authConfig()
          )
          .then(() => {
            this.$toast.open({
              message: this.$t("text.bExpenses.successfullyDeleted"),
              type: "success",
              duration: 5000,
            });
            this.getBranchExpenses();
          })
          .catch((error) => {
            this.$toast.open({
              message: error.response.data.message,
              type: "error",
              duration: 5000,
            });
          });
      }
    },
    toggleAccountTextBox() {
      this.$refs.toggleAccountTextBox.style.display = "none";
    },
    captureFormEvents($event) {
      if ($event.target.placeholder === this.$t("text.bExpenses.amount")) {
        if ($event.target.value === "") {
          this.$refs.amount_error.style.display = "block";
          this.$refs.amount_error.innerHTML = this.$t(
            "text.bExpenses.amountMissing"
          );
          this.$refs.amount_input_div.style.border = "1px solid red";
          this.$refs.amount_error.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.amount_error.style.display = "none";
          this.$refs.amount_error.innerHTML = "";
          this.$refs.amount_error.style.display = "none";
          this.$refs.amount_input_div.style.border =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
      if ($event.target.placeholder === this.$t("text.bExpenses.description")) {
        if ($event.target.value === "") {
          this.$refs.description_error.style.display = "block";
          this.$refs.description_error.innerHTML = this.$t(
            "text.bExpenses.descriptionMissing"
          );
          this.$refs.description_input_div.style.border = "1px solid red";
          this.$refs.description_error.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.description_error.style.display = "none";
          this.$refs.description_error.innerHTML = "";
          this.$refs.description_input_div.style.border =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
    },
    recordExpenses($event) {
      $event.preventDefault();
      if (!this.amount) {
        this.$toast.open({
          message: this.$t("text.bExpenses.amountMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (this.expenseCategoryId == "select category") {
        this.$toast.open({
          message: this.$t("text.bExpenses.expenseCategoryError"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (
        this.paymentMode !== "cash" &&
        this.accountNumber === "select account"
      ) {
        this.$toast.open({
          message: this.$t("text.bBankAccounts.selectAccountError"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.description) {
        this.$toast.open({
          message: this.$t("text.bExpenses.descriptionMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      const accountNo = this.paymentMode == "cash" ? "" : this.accountNumber;

      const data = {
        description: this.description,
        branchId: this.branchId,
        amount: Number.parseFloat(this.amount),
        paymentMode: this.paymentMode,
        accountNumber: accountNo,
      };

      let formData = new FormData();
      formData.append("Date", this.date);
      formData.append("Description", this.description);
      formData.append("BranchId", this.branchId);
      formData.append("Amount", Number.parseFloat(this.amount));
      formData.append("PaymentMode", this.paymentMode);
      formData.append("CategoryId", this.expenseCategoryId);
      formData.append("AccountNumber", accountNo);
      formData.append("File", this.file);

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Branch/RecordExpense`,
          formData,
          configObject.authConfig()
        )
        .then(() => {
          this.getBranchExpenses();
          this.$toast.open({
            message: this.$t("text.bExpenses.successfullyRecorded"),
            type: "success",
            duration: 20000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.description = null;
          this.amount = null;
          this.paymentMode = "cash";
          this.accountNumber = "select account";
        })
        .catch(() => {
          this.$toast.open({
            message: this.$t("text.bExpenses.unsuccessfulRecord"),
            type: "error",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
        });
    },
    changeRoute($newRoute) {
      this.$router.push({ name: $newRoute });
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    getBankAccts() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/BankAccounts/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          if (response.data !== null && response.data.length > 0) {
            // this.accountNumber = response.data[0].accountNumber;
          }
          this.bankAccounts = response.data;
        })
        .catch((error) => {});
    },
    getExpenseCategories() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/ExpenseCategories/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.expenseCategories = response.data;
        });
    },
    getBranchExpenses() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Expenses/${this.branchId}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.expenses = response.data.length;
          let index = 0;
          response.data.forEach((element) => {
            element.index = ++index;
            element.account =
              !element.account || element.account === "undefined"
                ? "N/A"
                : element.account;
          });
          this.showLoader = false;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
    convertThousand(request) {
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
